import type { EstimatorResult, Money } from "../types/index.js";

/**
 * Presentation-neutral helpers for working with an EstimatorResult.
 *
 * This module exists so the UI layer (and any future consumer - admin
 * dashboard, PDF export, WordPress shortcode) formats results consistently
 * without reimplementing rounding/locale logic, and without needing to
 * know anything about how the engine produced the numbers.
 */

export function formatMoneyCad(money: Money, locale = "en-CA"): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: money.currency,
    maximumFractionDigits: 0
  }).format(money.amount);
}

export function formatEstimateRange(result: EstimatorResult, locale = "en-CA"): string {
  return `${formatMoneyCad(result.estimate.low, locale)} - ${formatMoneyCad(result.estimate.high, locale)}`;
}

export function hasBlockingWarnings(result: EstimatorResult): boolean {
  return result.warnings.some((w) => w.severity === "blocking");
}

/** True when the result should not be presented to an end user as a real number. */
export function isDisplayableAsRealEstimate(result: EstimatorResult): boolean {
  return !result.isPlaceholderPricing && !hasBlockingWarnings(result);
}
